import { Cta } from "../components/Cta";
import { Section } from "../components/Section";
import { FRANCO_MODEL, KEV_MODEL, TEAM_INTRO } from "../content/team";
import { usePageMeta } from "../lib/usePageMeta";
import styles from "./Team.module.css";

/**
 * Meet the team.
 *
 * The landing page's Personas band gives each model a card, which separates
 * them without saying what either is for. This page does that, and it is the
 * page a reader lands on when they want to know what they would be buying.
 *
 * ORDER IS THE ARGUMENT. Kev's band ends on the fact that no odds feed is
 * connected and the price comparison is the reader's own step; Franco's band
 * then shows a model that DOES name a pick, because a lineup choice stakes
 * nothing, and closes on what neither model can see. Reordering
 * these bands breaks the reasoning — Franco reads as an inconsistency rather
 * than a control if he arrives before the reason Kev holds back.
 *
 * Same Section conventions as About: `level={1}` on the first band only so the
 * page has an h1, and `heroScroll` on that band because the hook reads
 * window.scrollY and only the first element makes that meaningful.
 */
export function Team() {
  usePageMeta("team");

  return (
    <>
      <Section
        id="team-intro"
        eyebrow={TEAM_INTRO.eyebrow}
        heading={TEAM_INTRO.heading}
        level={1}
        tone="ink"
        heroScroll
      >
        <div className={styles.prose}>
          {TEAM_INTRO.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section id="kev" eyebrow={KEV_MODEL.eyebrow} heading={KEV_MODEL.heading} tone="deep">
        <div className={styles.prose}>
          {KEV_MODEL.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section
        id="franco"
        eyebrow={FRANCO_MODEL.eyebrow}
        heading={FRANCO_MODEL.heading}
        tone="ink"
      >
        <div className={styles.prose}>
          {FRANCO_MODEL.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
          <p>{FRANCO_MODEL.limit}</p>
        </div>
        <div className={styles.ctaRow}>
          <Cta to="/pricing">{FRANCO_MODEL.cta}</Cta>
        </div>
      </Section>
    </>
  );
}
